import {observe} from '@github-ui/selector-observer'
import {remoteForm} from '@github-ui/remote-form'

let automaticallyLoadLatestRun = false

function showFlashMessage(template: HTMLTemplateElement) {
  const node = document.importNode(template.content, true)
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const flashContainer = document.querySelector<HTMLElement>('#js-flash-container')!
  for (const child of flashContainer.children) {
    flashContainer.removeChild(child)
  }
  flashContainer.appendChild(node)
}

function cleanCheckAndWait() {
  // Remove any check run specific info
  for (const element of document.querySelectorAll('.js-selected-check-run')) {
    element.remove()
  }

  // Show blankslate
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const blankslate = document.querySelector<HTMLElement>('.js-zen-blankslate')!
  blankslate.hidden = false

  // "Wait" until a link to the new check run appears
  automaticallyLoadLatestRun = true
}

remoteForm('.js-check-suite-rerequest-form', async function (form, wants) {
  const details = form.closest('details')
  if (!details) {
    return
  }

  details.removeAttribute('open') // close the dropdown menu
  const selectedCheckRun = document.querySelector('#js-selected-check-run')

  if (selectedCheckRun !== null) {
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    const input = form.querySelector<HTMLInputElement>('input[name=only_failed_check_runs]')!
    const onlyFailedCheckRuns = input.value === 'true'
    const failed = selectedCheckRun.getAttribute('data-failed') === 'true'
    if (!onlyFailedCheckRuns || failed) {
      cleanCheckAndWait()
    }
  }

  try {
    await wants.text()
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    showFlashMessage(document.querySelector<HTMLTemplateElement>('#js-check-suite-rerequest-form-success')!)
  } catch (err) {
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    showFlashMessage(document.querySelector<HTMLTemplateElement>('#js-check-suite-rerequest-form-error')!)
    throw err
  }
})

remoteForm('.js-check-run-rerequest-form', async function (form, wants) {
  automaticallyLoadLatestRun = true

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const selectedCheckRun = document.querySelector<HTMLElement>('#js-selected-check-run')!
  if (selectedCheckRun.contains(form)) {
    cleanCheckAndWait()
  }

  try {
    await wants.text()
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    showFlashMessage(form.querySelector<HTMLTemplateElement>('.js-check-run-rerequest-form-success')!)
  } catch (err) {
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    showFlashMessage(form.querySelector<HTMLTemplateElement>('.js-check-run-rerequest-form-error')!)
    throw err
  }
})

observe('.js-latest-run-link', {
  constructor: HTMLElement,
  add(link) {
    if (automaticallyLoadLatestRun) {
      link.click()
    }
  },
})
